import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Sidenav, Nav, Dropdown } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'
import Swal from 'sweetalert2'
import * as FaIcons from 'react-icons/fa';
import logo from '../../../../images/LAPELS-LOLA-Logo.png'

function Sidebar(props) {
    const [activeKey, setActiveKey] = React.useState();
    useEffect(() => {
        if (props.activeKey) {
            setActiveKey(props.activeKey);
        } else {
            var key = sessionStorage.getItem("currentSideNavKey");
            if (key) {
                setActiveKey(key);
            }
            else {
                setActiveKey("1");
                sessionStorage.setItem("currentSideNavKey", "1");
            }
        }
    }, [])
    const onSelect = (e) => {
        setActiveKey(e);
        sessionStorage.setItem("currentSideNavKey", e);
    }
    return (
        <div className='sidenav'>
            <Sidenav activeKey={activeKey} onSelect={onSelect}>
                <Sidenav.Header>
                    <div className='heads'>
                        <img src={logo} alt="Louisiana State Seal" style={{ width: '60px' }} />
                        <b> LOLA</b>
                    </div>
                </Sidenav.Header>
                <Sidenav.Body>
                    <Nav>
                        <Nav.Item eventKey="1" icon={<FaIcons.FaTh className="rs-icon sideBarIcon" />} as={Link} to="/firm/dashboard">
                            Dashboard
                        </Nav.Item>
                        <Nav.Item eventKey="2" icon={<FaIcons.FaIdCard className="rs-icon sideBarIcon" />} as={Link} to="/firm/contactinformation">
                            Update contact information
                        </Nav.Item>
                        <Nav.Item eventKey="3" icon={<FaIcons.FaClipboardList className="rs-icon sideBarIcon" />} as={Link} to="/firm/applications/">
                            Apply for a license/certification
                        </Nav.Item>
                        <Nav.Item eventKey="4" icon={<FaIcons.FaCertificate className="rs-icon sideBarIcon" />} as={Link} to="/firm/renewals/">
                            Renew a license/certification
                        </Nav.Item>
                        <Nav.Item eventKey="5" icon={<FaIcons.FaSyncAlt className="rs-icon sideBarIcon" />} as={Link} to="/firm/reinstatements/">
                            Reinstate a license/certification
                        </Nav.Item>
                        <Nav.Item eventKey="6" icon={<FaIcons.FaUsers className="rs-icon sideBarIcon" />} as={Link} target='_blank' to="/firm/supervisingprofessional">
                            Supervising Professional (SP) Locker
                        </Nav.Item>
                        <Dropdown eventKey="7" title="Other Online Services" icon={<FaIcons.FaToolbox className="rs-icon sideBarIcon" />}>
                            <Dropdown.Item href="https://www.lapels.com/quiz" target="_blank" eventKey="7-1">Online Quizzes</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/indivsearch" target="_blank" eventKey="7-2">Individual Search</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/firmsearch" target="_blank" eventKey="7-3">Firm Search</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/contact.html" target="_blank" eventKey="7-4">Contact Us</Dropdown.Item>
                            <Dropdown.Item href="https://www.google.com/maps/place/8550+United+Plaza+Blvd+Suite+903,+Baton+Rouge,+LA+70809/@30.4116425,-91.0994727,17z/data=!3m1!4b1!4m6!3m5!1s0x8626a48a786d3579:0x6dc2a640e72697a5!8m2!3d30.4116425!4d-91.0968978!16s%2Fg%2F11rzfxkjh9?hl=en&entry=ttu&g_ep=EgoyMDI1MDIxOS4xIKXMDSoASAFQAw%3D%3D" target="_blank" eventKey="7-5">Directions to LAPELS</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/LawsRules.html" target="_blank" eventKey="7-6">Laws and Rules</Dropdown.Item>
                            <Dropdown.Item href="https://www.lapels.com/board_meeting.html" target="_blank" eventKey="7-7">Board Meetings</Dropdown.Item>
                        </Dropdown>
                    </Nav>
                </Sidenav.Body>
            </Sidenav>
        </div>
    );
}

export default Sidebar;
